module.exports = __webpack_public_path__ + "a16b97ae29ebb190ddf5fa865f875e71.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VG.svg
// module id = xmqe
// module chunks = 0